import React from 'react'
import { FaFileInvoice, FaUsers } from 'react-icons/fa'
import { FiPackage } from 'react-icons/fi'
import {
    HiOutlineColorSwatch,
    HiOutlineDesktopComputer,
    HiOutlineTemplate,
    HiOutlineViewGridAdd,
    HiDocumentReport,
} from 'react-icons/hi'
import { MdPrivacyTip } from 'react-icons/md'
import { RiDashboardFill } from 'react-icons/ri'

const navigationIcon = {
    home: <RiDashboardFill />,
    titleFeed: <HiOutlineViewGridAdd />,
    collapseMenu: <HiOutlineTemplate />,
    groupSingleMenu: <HiOutlineDesktopComputer />,
    groupCollapseMenu: <HiOutlineColorSwatch />,
    users: <FaUsers />,
    packages: <FiPackage />,
    membership: <FaFileInvoice />,
    revBreak: <HiDocumentReport />,
    editTermsOfUse: <MdPrivacyTip />,
}

export default navigationIcon
